export default "__VITE_ASSET__2aa550f7__"